export default "__VITE_ASSET__1dd4ece6__"